/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptMakeupRequest,
  BadRequestResponse,
  ClassOccurrence,
  ClassOccurrencePage,
  ClassSeries,
  ClassSeriesPage,
  ConflictResponse,
  CreateClassSeriesRequest,
  CreateMakeupRequestBody,
  DeclineMakeupRequest,
  ForbiddenResponse,
  ListClassSeriesParams,
  ListMakeupRequestsParams,
  ListOccurrencesParams,
  ListScheduleChangeProposalsParams,
  ListScheduleCollisionsParams,
  MakeupRequest,
  MakeupRequestPage,
  NotFoundResponse,
  ResolveScheduleCollisionRequest,
  ScheduleChangeProposal,
  ScheduleChangeProposalPage,
  ScheduleChangeResponseRequest,
  ScheduleCollision,
  ScheduleCollisionPage,
  TeacherCancellationRequest,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListClassSeriesUrl = (params?: ListClassSeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/class-series?${stringifiedParams}` : `/v1/class-series`
}

/**
 * A recorrencia e ancorada no fuso do **aluno**: `anchorTimezone` guarda o
 * identificador IANA dele, e e a hora local dele que permanece estavel na
 * virada de horario de verao.
 * @summary Lista series de aula recorrentes
 */
export const listClassSeries = async (params?: ListClassSeriesParams, options?: Parameters<typeof apiFetch>[1]): Promise<ClassSeriesPage> => {

  return apiFetch<ClassSeriesPage>(getListClassSeriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClassSeriesQueryKey = (params?: ListClassSeriesParams,) => {
    return [
    `/v1/class-series`, ...(params ? [params] : [])
    ] as const;
    }


export const getListClassSeriesQueryOptions = <TData = Awaited<ReturnType<typeof listClassSeries>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListClassSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClassSeriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassSeries>>> = ({ signal }) => listClassSeries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListClassSeriesQueryResult = NonNullable<Awaited<ReturnType<typeof listClassSeries>>>
export type ListClassSeriesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListClassSeries<TData = Awaited<ReturnType<typeof listClassSeries>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListClassSeriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClassSeries>>,
          TError,
          Awaited<ReturnType<typeof listClassSeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClassSeries<TData = Awaited<ReturnType<typeof listClassSeries>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListClassSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClassSeries>>,
          TError,
          Awaited<ReturnType<typeof listClassSeries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClassSeries<TData = Awaited<ReturnType<typeof listClassSeries>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListClassSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista series de aula recorrentes
 */

export function useListClassSeries<TData = Awaited<ReturnType<typeof listClassSeries>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListClassSeriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassSeries>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClassSeriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateClassSeriesUrl = () => {




  return `/v1/class-series`
}

/**
 * Exclusiva de Super Admin. A criacao materializa ocorrencias na janela
 * rolante de 90 dias.
 * @summary Cria uma serie de aula recorrente
 */
export const createClassSeries = async (createClassSeriesRequest: CreateClassSeriesRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ClassSeries> => {

  return apiFetch<ClassSeries>(getCreateClassSeriesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createClassSeriesRequest)
  }
);}





export const getCreateClassSeriesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassSeries>>, TError,{data: CreateClassSeriesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createClassSeries>>, TError,{data: CreateClassSeriesRequest}, TContext> => {

const mutationKey = ['createClassSeries'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassSeries>>, {data: CreateClassSeriesRequest}> = (props) => {
          const {data} = props ?? {};

          return  createClassSeries(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClassSeriesMutationResult = NonNullable<Awaited<ReturnType<typeof createClassSeries>>>
    export type CreateClassSeriesMutationBody = CreateClassSeriesRequest
    export type CreateClassSeriesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Cria uma serie de aula recorrente
 */
export const useCreateClassSeries = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassSeries>>, TError,{data: CreateClassSeriesRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createClassSeries>>,
        TError,
        {data: CreateClassSeriesRequest},
        TContext
      > => {
      return useMutation(getCreateClassSeriesMutationOptions(options), queryClient);
    }
    export const getListOccurrencesUrl = (params: ListOccurrencesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/occurrences?${stringifiedParams}` : `/v1/occurrences`
}

/**
 * Aluno alcanca somente as proprias ocorrencias, professor somente as dele,
 * Super Admin todas. `from` e `to` sao instantes UTC; a exibicao no fuso da
 * pessoa e responsabilidade do cliente, que recebe o fuso em `GET /v1/me`.
 * @summary Lista ocorrencias de aula em um periodo
 */
export const listOccurrences = async (params: ListOccurrencesParams, options?: Parameters<typeof apiFetch>[1]): Promise<ClassOccurrencePage> => {

  return apiFetch<ClassOccurrencePage>(getListOccurrencesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOccurrencesQueryKey = (params?: ListOccurrencesParams,) => {
    return [
    `/v1/occurrences`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOccurrencesQueryOptions = <TData = Awaited<ReturnType<typeof listOccurrences>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(params: ListOccurrencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOccurrencesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOccurrences>>> = ({ signal }) => listOccurrences(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOccurrencesQueryResult = NonNullable<Awaited<ReturnType<typeof listOccurrences>>>
export type ListOccurrencesQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse


export function useListOccurrences<TData = Awaited<ReturnType<typeof listOccurrences>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(
 params: ListOccurrencesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOccurrences>>,
          TError,
          Awaited<ReturnType<typeof listOccurrences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOccurrences<TData = Awaited<ReturnType<typeof listOccurrences>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(
 params: ListOccurrencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOccurrences>>,
          TError,
          Awaited<ReturnType<typeof listOccurrences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOccurrences<TData = Awaited<ReturnType<typeof listOccurrences>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(
 params: ListOccurrencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista ocorrencias de aula em um periodo
 */

export function useListOccurrences<TData = Awaited<ReturnType<typeof listOccurrences>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(
 params: ListOccurrencesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOccurrences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOccurrencesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOccurrenceUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}`
}

/**
 * Detalha uma ocorrencia de aula. Participante da aula e Super Admin.
 *
 * E por aqui que se dereferencia o `occurrenceId` que aparece em `payroll`,
 * em `academic` e em `attendance`.
 * @summary Detalha uma ocorrencia de aula
 */
export const getOccurrence = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ClassOccurrence> => {

  return apiFetch<ClassOccurrence>(getGetOccurrenceUrl(occurrenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOccurrenceQueryKey = (occurrenceId: string,) => {
    return [
    `/v1/occurrences/${occurrenceId}`
    ] as const;
    }


export const getGetOccurrenceQueryOptions = <TData = Awaited<ReturnType<typeof getOccurrence>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOccurrenceQueryKey(occurrenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOccurrence>>> = ({ signal }) => getOccurrence(occurrenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: occurrenceId !== null && occurrenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOccurrenceQueryResult = NonNullable<Awaited<ReturnType<typeof getOccurrence>>>
export type GetOccurrenceQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetOccurrence<TData = Awaited<ReturnType<typeof getOccurrence>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrence>>,
          TError,
          Awaited<ReturnType<typeof getOccurrence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrence<TData = Awaited<ReturnType<typeof getOccurrence>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrence>>,
          TError,
          Awaited<ReturnType<typeof getOccurrence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrence<TData = Awaited<ReturnType<typeof getOccurrence>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha uma ocorrencia de aula
 */

export function useGetOccurrence<TData = Awaited<ReturnType<typeof getOccurrence>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrence>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOccurrenceQueryOptions(occurrenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCancelOccurrenceByStudentUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/student-cancellation`
}

/**
 * O aluno pode desmarcar a qualquer momento, sem antecedencia minima. A
 * sala nao abre, nao ha gravacao, e o item de folha do professor nasce
 * `held` aguardando reposicao.
 * @summary Aluno desmarca a propria aula
 */
export const cancelOccurrenceByStudent = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ClassOccurrence> => {

  return apiFetch<ClassOccurrence>(getCancelOccurrenceByStudentUrl(occurrenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelOccurrenceByStudentMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByStudent>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByStudent>>, TError,{occurrenceId: string}, TContext> => {

const mutationKey = ['cancelOccurrenceByStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOccurrenceByStudent>>, {occurrenceId: string}> = (props) => {
          const {occurrenceId} = props ?? {};

          return  cancelOccurrenceByStudent(occurrenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOccurrenceByStudentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOccurrenceByStudent>>>

    export type CancelOccurrenceByStudentMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Aluno desmarca a propria aula
 */
export const useCancelOccurrenceByStudent = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByStudent>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOccurrenceByStudent>>,
        TError,
        {occurrenceId: string},
        TContext
      > => {
      return useMutation(getCancelOccurrenceByStudentMutationOptions(options), queryClient);
    }
    export const getCancelOccurrenceByTeacherUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/teacher-cancellation`
}

/**
 * Permitido ate 24 h antes do inicio; depois disso responde 409. O item de
 * folha resultante e `void`: o professor nao recebe por aula que ele mesmo
 * desmarcou.
 * @summary Professor desmarca uma aula
 */
export const cancelOccurrenceByTeacher = async (occurrenceId: string,
    teacherCancellationRequest: TeacherCancellationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ClassOccurrence> => {

  return apiFetch<ClassOccurrence>(getCancelOccurrenceByTeacherUrl(occurrenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(teacherCancellationRequest)
  }
);}





export const getCancelOccurrenceByTeacherMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>, TError,{occurrenceId: string;data: TeacherCancellationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>, TError,{occurrenceId: string;data: TeacherCancellationRequest}, TContext> => {

const mutationKey = ['cancelOccurrenceByTeacher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>, {occurrenceId: string;data: TeacherCancellationRequest}> = (props) => {
          const {occurrenceId,data} = props ?? {};

          return  cancelOccurrenceByTeacher(occurrenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelOccurrenceByTeacherMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>>
    export type CancelOccurrenceByTeacherMutationBody = TeacherCancellationRequest
    export type CancelOccurrenceByTeacherMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Professor desmarca uma aula
 */
export const useCancelOccurrenceByTeacher = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>, TError,{occurrenceId: string;data: TeacherCancellationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOccurrenceByTeacher>>,
        TError,
        {occurrenceId: string;data: TeacherCancellationRequest},
        TContext
      > => {
      return useMutation(getCancelOccurrenceByTeacherMutationOptions(options), queryClient);
    }
    export const getListScheduleChangeProposalsUrl = (params?: ListScheduleChangeProposalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/schedule-change-proposals?${stringifiedParams}` : `/v1/schedule-change-proposals`
}

/**
 * Uma proposta nasce quando a virada de horario de verao move a aula na
 * hora local de um dos participantes. O aviso sai 14 dias antes.
 * @summary Lista propostas de mudanca de horario
 */
export const listScheduleChangeProposals = async (params?: ListScheduleChangeProposalsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ScheduleChangeProposalPage> => {

  return apiFetch<ScheduleChangeProposalPage>(getListScheduleChangeProposalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScheduleChangeProposalsQueryKey = (params?: ListScheduleChangeProposalsParams,) => {
    return [
    `/v1/schedule-change-proposals`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScheduleChangeProposalsQueryOptions = <TData = Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListScheduleChangeProposalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScheduleChangeProposalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScheduleChangeProposals>>> = ({ signal }) => listScheduleChangeProposals(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScheduleChangeProposalsQueryResult = NonNullable<Awaited<ReturnType<typeof listScheduleChangeProposals>>>
export type ListScheduleChangeProposalsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListScheduleChangeProposals<TData = Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListScheduleChangeProposalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduleChangeProposals>>,
          TError,
          Awaited<ReturnType<typeof listScheduleChangeProposals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduleChangeProposals<TData = Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleChangeProposalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduleChangeProposals>>,
          TError,
          Awaited<ReturnType<typeof listScheduleChangeProposals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduleChangeProposals<TData = Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleChangeProposalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista propostas de mudanca de horario
 */

export function useListScheduleChangeProposals<TData = Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleChangeProposalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleChangeProposals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScheduleChangeProposalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRespondToScheduleChangeProposalUrl = (proposalId: string,) => {




  return `/v1/schedule-change-proposals/${proposalId}/response`
}

/**
 * @summary Aceita ou recusa uma proposta de mudanca de horario
 */
export const respondToScheduleChangeProposal = async (proposalId: string,
    scheduleChangeResponseRequest: ScheduleChangeResponseRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ScheduleChangeProposal> => {

  return apiFetch<ScheduleChangeProposal>(getRespondToScheduleChangeProposalUrl(proposalId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduleChangeResponseRequest)
  }
);}





export const getRespondToScheduleChangeProposalMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToScheduleChangeProposal>>, TError,{proposalId: string;data: ScheduleChangeResponseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToScheduleChangeProposal>>, TError,{proposalId: string;data: ScheduleChangeResponseRequest}, TContext> => {

const mutationKey = ['respondToScheduleChangeProposal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToScheduleChangeProposal>>, {proposalId: string;data: ScheduleChangeResponseRequest}> = (props) => {
          const {proposalId,data} = props ?? {};

          return  respondToScheduleChangeProposal(proposalId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondToScheduleChangeProposalMutationResult = NonNullable<Awaited<ReturnType<typeof respondToScheduleChangeProposal>>>
    export type RespondToScheduleChangeProposalMutationBody = ScheduleChangeResponseRequest
    export type RespondToScheduleChangeProposalMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Aceita ou recusa uma proposta de mudanca de horario
 */
export const useRespondToScheduleChangeProposal = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToScheduleChangeProposal>>, TError,{proposalId: string;data: ScheduleChangeResponseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof respondToScheduleChangeProposal>>,
        TError,
        {proposalId: string;data: ScheduleChangeResponseRequest},
        TContext
      > => {
      return useMutation(getRespondToScheduleChangeProposalMutationOptions(options), queryClient);
    }
    export const getListScheduleCollisionsUrl = (params?: ListScheduleCollisionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/schedule-collisions?${stringifiedParams}` : `/v1/schedule-collisions`
}

/**
 * Colisao de grade **nunca** e resolvida automaticamente. A fila existe
 * para que uma pessoa decida, e por isso e uma tela e nao um job.
 * @summary Lista a fila de colisoes de grade do Super Admin
 */
export const listScheduleCollisions = async (params?: ListScheduleCollisionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ScheduleCollisionPage> => {

  return apiFetch<ScheduleCollisionPage>(getListScheduleCollisionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScheduleCollisionsQueryKey = (params?: ListScheduleCollisionsParams,) => {
    return [
    `/v1/schedule-collisions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScheduleCollisionsQueryOptions = <TData = Awaited<ReturnType<typeof listScheduleCollisions>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListScheduleCollisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScheduleCollisionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScheduleCollisions>>> = ({ signal }) => listScheduleCollisions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScheduleCollisionsQueryResult = NonNullable<Awaited<ReturnType<typeof listScheduleCollisions>>>
export type ListScheduleCollisionsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListScheduleCollisions<TData = Awaited<ReturnType<typeof listScheduleCollisions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListScheduleCollisionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduleCollisions>>,
          TError,
          Awaited<ReturnType<typeof listScheduleCollisions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduleCollisions<TData = Awaited<ReturnType<typeof listScheduleCollisions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleCollisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduleCollisions>>,
          TError,
          Awaited<ReturnType<typeof listScheduleCollisions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduleCollisions<TData = Awaited<ReturnType<typeof listScheduleCollisions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleCollisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista a fila de colisoes de grade do Super Admin
 */

export function useListScheduleCollisions<TData = Awaited<ReturnType<typeof listScheduleCollisions>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListScheduleCollisionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduleCollisions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScheduleCollisionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResolveScheduleCollisionUrl = (collisionId: string,) => {




  return `/v1/schedule-collisions/${collisionId}/resolution`
}

/**
 * Exclusiva de Super Admin.
 * @summary Resolve manualmente uma colisao de grade
 */
export const resolveScheduleCollision = async (collisionId: string,
    resolveScheduleCollisionRequest: ResolveScheduleCollisionRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ScheduleCollision> => {

  return apiFetch<ScheduleCollision>(getResolveScheduleCollisionUrl(collisionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveScheduleCollisionRequest)
  }
);}





export const getResolveScheduleCollisionMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveScheduleCollision>>, TError,{collisionId: string;data: ResolveScheduleCollisionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveScheduleCollision>>, TError,{collisionId: string;data: ResolveScheduleCollisionRequest}, TContext> => {

const mutationKey = ['resolveScheduleCollision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveScheduleCollision>>, {collisionId: string;data: ResolveScheduleCollisionRequest}> = (props) => {
          const {collisionId,data} = props ?? {};

          return  resolveScheduleCollision(collisionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveScheduleCollisionMutationResult = NonNullable<Awaited<ReturnType<typeof resolveScheduleCollision>>>
    export type ResolveScheduleCollisionMutationBody = ResolveScheduleCollisionRequest
    export type ResolveScheduleCollisionMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Resolve manualmente uma colisao de grade
 */
export const useResolveScheduleCollision = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveScheduleCollision>>, TError,{collisionId: string;data: ResolveScheduleCollisionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveScheduleCollision>>,
        TError,
        {collisionId: string;data: ResolveScheduleCollisionRequest},
        TContext
      > => {
      return useMutation(getResolveScheduleCollisionMutationOptions(options), queryClient);
    }
    export const getListMakeupRequestsUrl = (params?: ListMakeupRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/makeup-requests?${stringifiedParams}` : `/v1/makeup-requests`
}

/**
 * Aluno ve os proprios, professor os enderecados a ele, Super Admin todos.
 * @summary Lista pedidos de reposicao
 */
export const listMakeupRequests = async (params?: ListMakeupRequestsParams, options?: Parameters<typeof apiFetch>[1]): Promise<MakeupRequestPage> => {

  return apiFetch<MakeupRequestPage>(getListMakeupRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMakeupRequestsQueryKey = (params?: ListMakeupRequestsParams,) => {
    return [
    `/v1/makeup-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMakeupRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listMakeupRequests>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListMakeupRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMakeupRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMakeupRequests>>> = ({ signal }) => listMakeupRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMakeupRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listMakeupRequests>>>
export type ListMakeupRequestsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListMakeupRequests<TData = Awaited<ReturnType<typeof listMakeupRequests>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListMakeupRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMakeupRequests>>,
          TError,
          Awaited<ReturnType<typeof listMakeupRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMakeupRequests<TData = Awaited<ReturnType<typeof listMakeupRequests>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMakeupRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMakeupRequests>>,
          TError,
          Awaited<ReturnType<typeof listMakeupRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMakeupRequests<TData = Awaited<ReturnType<typeof listMakeupRequests>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMakeupRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista pedidos de reposicao
 */

export function useListMakeupRequests<TData = Awaited<ReturnType<typeof listMakeupRequests>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListMakeupRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMakeupRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMakeupRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAcceptMakeupRequestUrl = (makeupRequestId: string,) => {




  return `/v1/makeup-requests/${makeupRequestId}/acceptance`
}

/**
 * Aceitar anula o item de folha da aula original e cria uma ocorrencia
 * nova de tipo `makeup`, que segue a regra normal. Reposicao nao gera
 * reposicao: e o corte que impede laco infinito.
 * @summary Professor aceita um pedido de reposicao
 */
export const acceptMakeupRequest = async (makeupRequestId: string,
    acceptMakeupRequest: AcceptMakeupRequest, options?: Parameters<typeof apiFetch>[1]): Promise<MakeupRequest> => {

  return apiFetch<MakeupRequest>(getAcceptMakeupRequestUrl(makeupRequestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptMakeupRequest)
  }
);}





export const getAcceptMakeupRequestMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptMakeupRequest>>, TError,{makeupRequestId: string;data: AcceptMakeupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptMakeupRequest>>, TError,{makeupRequestId: string;data: AcceptMakeupRequest}, TContext> => {

const mutationKey = ['acceptMakeupRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptMakeupRequest>>, {makeupRequestId: string;data: AcceptMakeupRequest}> = (props) => {
          const {makeupRequestId,data} = props ?? {};

          return  acceptMakeupRequest(makeupRequestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptMakeupRequestMutationResult = NonNullable<Awaited<ReturnType<typeof acceptMakeupRequest>>>
    export type AcceptMakeupRequestMutationBody = AcceptMakeupRequest
    export type AcceptMakeupRequestMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Professor aceita um pedido de reposicao
 */
export const useAcceptMakeupRequest = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptMakeupRequest>>, TError,{makeupRequestId: string;data: AcceptMakeupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptMakeupRequest>>,
        TError,
        {makeupRequestId: string;data: AcceptMakeupRequest},
        TContext
      > => {
      return useMutation(getAcceptMakeupRequestMutationOptions(options), queryClient);
    }
    export const getDeclineMakeupRequestUrl = (makeupRequestId: string,) => {




  return `/v1/makeup-requests/${makeupRequestId}/decline`
}

/**
 * Recusar torna o item de folha `void`: o professor abriu mao da aula.
 * @summary Professor recusa um pedido de reposicao
 */
export const declineMakeupRequest = async (makeupRequestId: string,
    declineMakeupRequest: DeclineMakeupRequest, options?: Parameters<typeof apiFetch>[1]): Promise<MakeupRequest> => {

  return apiFetch<MakeupRequest>(getDeclineMakeupRequestUrl(makeupRequestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(declineMakeupRequest)
  }
);}





export const getDeclineMakeupRequestMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineMakeupRequest>>, TError,{makeupRequestId: string;data: DeclineMakeupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof declineMakeupRequest>>, TError,{makeupRequestId: string;data: DeclineMakeupRequest}, TContext> => {

const mutationKey = ['declineMakeupRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineMakeupRequest>>, {makeupRequestId: string;data: DeclineMakeupRequest}> = (props) => {
          const {makeupRequestId,data} = props ?? {};

          return  declineMakeupRequest(makeupRequestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineMakeupRequestMutationResult = NonNullable<Awaited<ReturnType<typeof declineMakeupRequest>>>
    export type DeclineMakeupRequestMutationBody = DeclineMakeupRequest
    export type DeclineMakeupRequestMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Professor recusa um pedido de reposicao
 */
export const useDeclineMakeupRequest = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineMakeupRequest>>, TError,{makeupRequestId: string;data: DeclineMakeupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineMakeupRequest>>,
        TError,
        {makeupRequestId: string;data: DeclineMakeupRequest},
        TContext
      > => {
      return useMutation(getDeclineMakeupRequestMutationOptions(options), queryClient);
    }
    export const getCreateMakeupRequestUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/makeup-request`
}

/**
 * O pedido nasce da ocorrencia perdida, nao de uma escolha de aluno numa
 * lista. A janela vai ate sabado 12h da semana corrente e nao rola para a
 * semana seguinte; o teto e de duas reposicoes por semana por aluno; a
 * antecedencia minima e 24 h. Fora disso a resposta e 409.
 *
 * Aula em dupla nao tem reposicao, e reposicao nao gera reposicao.
 * @summary Aluno pede reposicao de uma aula perdida
 */
export const createMakeupRequest = async (occurrenceId: string,
    createMakeupRequestBody: CreateMakeupRequestBody, options?: Parameters<typeof apiFetch>[1]): Promise<MakeupRequest> => {

  return apiFetch<MakeupRequest>(getCreateMakeupRequestUrl(occurrenceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMakeupRequestBody)
  }
);}





export const getCreateMakeupRequestMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMakeupRequest>>, TError,{occurrenceId: string;data: CreateMakeupRequestBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMakeupRequest>>, TError,{occurrenceId: string;data: CreateMakeupRequestBody}, TContext> => {

const mutationKey = ['createMakeupRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMakeupRequest>>, {occurrenceId: string;data: CreateMakeupRequestBody}> = (props) => {
          const {occurrenceId,data} = props ?? {};

          return  createMakeupRequest(occurrenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMakeupRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createMakeupRequest>>>
    export type CreateMakeupRequestMutationBody = CreateMakeupRequestBody
    export type CreateMakeupRequestMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Aluno pede reposicao de uma aula perdida
 */
export const useCreateMakeupRequest = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMakeupRequest>>, TError,{occurrenceId: string;data: CreateMakeupRequestBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMakeupRequest>>,
        TError,
        {occurrenceId: string;data: CreateMakeupRequestBody},
        TContext
      > => {
      return useMutation(getCreateMakeupRequestMutationOptions(options), queryClient);
    }
